export const ROUTE_CONTEXT = Symbol('ROUTE_CONTEXT');
export const LOCATION_CONTEXT = Symbol('LOCATION_CONTEXT');
